import { PropsWithChildren, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useDeprecatedIntegratedUnitQueueStore } from './use-deprecated-integrated-unit-queue-store';
import { useDispatchAreaStore } from '../../dispatch-areas/use-dispatch-areas';
import { QueueStateContext } from '../../queues/context/queue-state-context';
import { UnitQueueStore } from '../store/unit-queue-store';
import { WorkspacePanel } from '../../panels/workspace-panel';
import { workspacePanelIsQueue } from '../../panels/workspace-queue-exists';
import { WorkspaceQueue } from '../../panels/workspace-queue';
import { useRegisterQueueStore } from '../../queues/queue-registry/use-register-queue-store';
import { useUnitTimersStore } from '../../unit-timers/use-unit-timers-store';
import { useEventNotificationsStore } from '../../event-notifications/use-event-notifications';

export const DeprecatedUnitQueueStateProvider = observer(function UnitQueueStateProvider({
    workspacePanel,
    children,
}: PropsWithChildren<{
    workspacePanel: WorkspacePanel;
}>): React.ReactElement {
    workspacePanelIsQueue(workspacePanel);
    const { monitoredAndOwnedDispatchAreaIds: dispatchAreaIds } = useDispatchAreaStore();
    const unitTimersStore = useUnitTimersStore();
    const eventNotificationsStore = useEventNotificationsStore();
    const store = useState(
        () => new UnitQueueStore({ workspacePanel, eventNotificationsStore, unitTimersStore })
    )[0];
    useRegisterQueueStore(store);

    const unitTypeAttrIds = useMemo(() => {
        return (
            store.workspacePanel.queue.unitTypeFilters?.map(
                (unitTypeFilter: WorkspaceQueue['unitTypeFilters'][number]) =>
                    unitTypeFilter.attributeId
            ) ?? []
        );
    }, [store.workspacePanel.queue.unitTypeFilters]);

    const unitQueueFilters = useMemo(() => {
        return store.workspacePanel.queue.unitQueueColumnFilters ?? [];
    }, [store.workspacePanel.queue.unitQueueColumnFilters]);

    useDeprecatedIntegratedUnitQueueStore({
        store,
        workspacePanel,
        dispatchAreaIds,
        isPinToPrimaryActive: !!store.workspacePanel.queue.pinBackupsToPrimaryUnits,
        unitTypeAttrIds,
        unitQueueFilters,
    });

    return <QueueStateContext.Provider value={store}>{children}</QueueStateContext.Provider>;
});
